export enum TrailerAvailability {
    available,
    confirmedAvailable,
    pendingAvailable,
    noTag,
}
